import apiClient from './client';
import type {
  ApiResponse,
  TokenResponse,
  LoginRequest,
  ActivationRequest,
  CompleteActivationRequest,
  RecoveryRequest,
  CompleteRecoveryRequest,
} from './types';

const AUTH_BASE = '/auth';

/**
 * Login with email and password
 */
export async function login(request: LoginRequest): Promise<ApiResponse<TokenResponse>> {
  const response = await apiClient.post<ApiResponse<TokenResponse>>(
    `${AUTH_BASE}/login`,
    {
      ...request,
      credentialType: request.credentialType || 'password',
    }
  );
  return response.data;
}

/**
 * Request activation code
 */
export async function requestActivation(request: ActivationRequest): Promise<ApiResponse> {
  const response = await apiClient.post<ApiResponse>(
    `${AUTH_BASE}/activation/request`,
    request
  );
  return response.data;
}

/**
 * Complete activation with code and set password
 */
export async function completeActivation(
  request: CompleteActivationRequest
): Promise<ApiResponse<TokenResponse>> {
  const response = await apiClient.post<ApiResponse<TokenResponse>>(
    `${AUTH_BASE}/activation/complete`,
    request
  );
  return response.data;
}

/**
 * Request password recovery code
 */
export async function requestRecovery(request: RecoveryRequest): Promise<ApiResponse> {
  const response = await apiClient.post<ApiResponse>(
    `${AUTH_BASE}/recovery/request`,
    request
  );
  return response.data;
}

/**
 * Complete password recovery with code and new password
 */
export async function completeRecovery(
  request: CompleteRecoveryRequest
): Promise<ApiResponse<TokenResponse>> {
  const response = await apiClient.post<ApiResponse<TokenResponse>>(
    `${AUTH_BASE}/recovery/complete`,
    request
  );
  return response.data;
}

export const authApi = {
  login,
  requestActivation,
  completeActivation,
  requestRecovery,
  completeRecovery,
};
